import axios from "axios";
import Swal from "sweetalert2";

export const getLoyaltySettings = async (page, filters) => {
    try {
      const brear = localStorage.getItem("token");
      const lang = localStorage.getItem("i18nextLng")
      const { data } = await axios.get(
        "/v1/admin/loyaltysettings",
        {
          params: {
            page,
            ...filters
          },
          headers: {
            Authorization: "Bearer " + `${brear}`,
            app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
            lang: lang
          }
        }
      );
      return data;
    } catch (error) {
      throw error
    }
  };

export const showLoyaltySetting = async (id) => {
    try {
      const brear = localStorage.getItem("token");
      const lang = localStorage.getItem("i18nextLng")
      const { data } = await axios.get(
        `/v1/admin/loyaltysettings/${id}`,
        {
          headers: {
            Authorization: "Bearer " + `${brear}`,
            app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
            lang: lang
          }
        }
      );
      return data;
    } catch (error) {
      throw error
    }
  };

export const postLoyaltySetting = async (postData) => {
    try {
      const brear = localStorage.getItem("token");
      const lang = localStorage.getItem("i18nextLng")
      const { data } = await axios.post(
        "/v1/admin/loyaltysettings", postData,
        {
          headers: {
            Authorization: "Bearer " + `${brear}`,
            app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
            lang: lang
          }
        }
      );
      return data;
    } catch (error) {
      throw error
    }
  };

export const updateLoyaltySetting = async (postData, id) => {
    try {
      const brear = localStorage.getItem("token");
      const lang = localStorage.getItem("i18nextLng")
      const { data } = await axios.post(
        `/v1/admin/loyaltysettings/${id}`, postData,
        {
          headers: {
            Authorization: "Bearer " + `${brear}`,
            app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
            lang: lang
          }
        }
      );
      return data;
    } catch (error) {
      throw error
    }
  };

export const deleteLoyaltySetting = async (id, lang) => {
  const brear = localStorage.getItem("token");
  const result = await Swal.fire({
    title: "هل انت متأكد ؟",
    text: "سيتم الحذف",
    icon: "warning",
    showCancelButton: true,
    cancelButtonColor: "#d33",
    confirmButtonText: "Okay",
  });
  if (result.isConfirmed) {
    try {
      const { data } = await axios.delete(`/v1/admin/loyaltysettings/${id}`, {
        headers: {
          Authorization: "Bearer " + `${brear}`,
          app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
          AcceptLanguage: lang,
        }
      });
      if (data.success === true) {
        Swal.fire("Deleted!", `${data.message}`, "success");
      } else {
        Swal.fire("Not deleted", `${data.message}`, "info");
      }
      return data;
    } catch (error) {
      throw error;
    }
  }
};